import { render, staticRenderFns } from "./ValeResguardo.vue?vue&type=template&id=5143cce5&scoped=true"
import script from "./ValeResguardo.vue?vue&type=script&lang=js"
export * from "./ValeResguardo.vue?vue&type=script&lang=js"
import style0 from "./ValeResguardo.vue?vue&type=style&index=0&id=5143cce5&prod&scoped=true&lang=css"
import style1 from "./ValeResguardo.vue?vue&type=style&index=1&id=5143cce5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143cce5",
  null
  
)

export default component.exports